import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus, BoxIcon } from 'lucide-react';
import { Card, CardContent } from './Card';
import { cn } from '../../lib/utils';
interface StatCardProps {
  title: string;
  value: string;
  icon: BoxIcon;
  description?: string;
  trend?: {
    value: string;
    direction: 'up' | 'down' | 'neutral';
  };
  className?: string;
  delay?: number;
}
export function StatCard({
  title,
  value,
  icon: Icon,
  description,
  trend,
  className,
  delay = 0
}: StatCardProps) {
  return <Card className={cn('border-none shadow-md hover:shadow-lg transition-all duration-300 animate-slide-up bg-white', className)} style={{
    animationDelay: `${delay}ms`
  }} data-id="element-433">
      <CardContent className="p-6" data-id="element-434">
        <div className="flex items-center justify-between mb-4" data-id="element-435">
          <div className="p-2 bg-primary-50 rounded-lg text-primary-600 transition-colors group-hover:bg-primary-100" data-id="element-436">
            <Icon className="h-6 w-6" data-id="element-437" />
          </div>
          {trend && <div className={cn('flex items-center text-xs font-medium px-2 py-1 rounded-full', trend.direction === 'up' && 'text-green-700 bg-green-50', trend.direction === 'down' && 'text-red-700 bg-red-50', trend.direction === 'neutral' && 'text-gray-700 bg-gray-50')} data-id="element-438">
              {trend.direction === 'up' && <ArrowUpRight className="h-3 w-3 mr-1" data-id="element-439" />}
              {trend.direction === 'down' && <ArrowDownRight className="h-3 w-3 mr-1" data-id="element-440" />}
              {trend.direction === 'neutral' && <Minus className="h-3 w-3 mr-1" data-id="element-441" />}
              {trend.value}
            </div>}
        </div>

        <div className="space-y-1" data-id="element-442">
          <h3 className="text-sm font-medium text-gray-500" data-id="element-443">{title}</h3>
          <div className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-444">
            {value}
          </div>
          {description && <p className="text-xs text-gray-500 mt-1" data-id="element-445">{description}</p>}
        </div>
      </CardContent>
    </Card>;
}